import React from 'react';
import { OrderTutorialContainer, OrderTutorialItem, OrderTutorialImage, OrderTutorialList, OrderTutorialHeader, OrderTutorialButton, OrderTutorialItemList, OrderTutorialItemListItem } from './OrderTutorial.styled';
import OrderTutorialStep1 from '../../assets/order-tutorial-step-1.png';
import OrderTutorialStep2 from '../../assets/order-tutorial-step-2.png';
import OrderTutorialStep3 from '../../assets/order-tutorial-step-3.png';
import OrderTutorialStep4 from '../../assets/order-tutorial-step-4.png';
import { useNavigate } from 'react-router';


const OurValues = () => {
  const navigate = useNavigate();
  return (
    <OrderTutorialContainer fluid id="order-tutorial">
      <OrderTutorialHeader>Cara Memesan</OrderTutorialHeader>
      <OrderTutorialList>
        <OrderTutorialItem>
          <OrderTutorialImage src={OrderTutorialStep1} alt="order-tutorial-step-1" />
          <OrderTutorialItemList>
            <OrderTutorialItemListItem>Pilih Produk, varian, dan jumlah yang diinginkan.</OrderTutorialItemListItem>
            <OrderTutorialItemListItem>Pencet tombol "Masukan Produk".</OrderTutorialItemListItem>
          </OrderTutorialItemList>
        </OrderTutorialItem>
        <OrderTutorialItem>
          <OrderTutorialImage src={OrderTutorialStep2} alt="order-tutorial-step-2" />
          <OrderTutorialItemList>
            <OrderTutorialItemListItem>Isi data diri pada form Quotation Request.</OrderTutorialItemListItem>
            <OrderTutorialItemListItem>Pencet tombol "Submit Quotation".</OrderTutorialItemListItem>
          </OrderTutorialItemList>
        </OrderTutorialItem>
        <OrderTutorialItem>
          <OrderTutorialImage src={OrderTutorialStep3} alt="order-tutorial-step-3" />
          <OrderTutorialItemList>
            <OrderTutorialItemListItem>Produk dan jumlah pilihan Anda akan dikirim ke WhatsApp MCup.</OrderTutorialItemListItem>
            <OrderTutorialItemListItem>Team MCup akan segera membalas pesan anda.</OrderTutorialItemListItem>
          </OrderTutorialItemList>
        </OrderTutorialItem>
        <OrderTutorialItem>
          <OrderTutorialImage src={OrderTutorialStep4} alt="order-tutorial-step-4" />
          <OrderTutorialItemList>
            <OrderTutorialItemListItem>Lakukan pembayaran.</OrderTutorialItemListItem>
            <OrderTutorialItemListItem>Kirim alamat tujuan pesanan Anda.</OrderTutorialItemListItem>
            <OrderTutorialItemListItem>Pesanan akan dikirim segera.</OrderTutorialItemListItem>
          </OrderTutorialItemList>
        </OrderTutorialItem>
      </OrderTutorialList>
      <OrderTutorialButton onClick={() => navigate('/products?category=all-products')}>Semua Produk</OrderTutorialButton>
    </OrderTutorialContainer>
    
  )
}

export default OurValues;